import type { Workspace } from '../types/workspace.types'

/**
 * Resolves lastUsedProjectId for a workspace id from current or listed workspaces.
 */
export function getLastUsedProjectIdForWorkspace(
  workspaces: Workspace[],
  currentWorkspace: Workspace | null,
  workspaceId: string
): string | null {
  if (currentWorkspace?.id === workspaceId) {
    return currentWorkspace.lastUsedProjectId
  }

  return workspaces.find((workspace) => workspace.id === workspaceId)?.lastUsedProjectId ?? null
}
